import Control from '@/Controls/Control';
import ComponentManager from '@/Management/ComponentManager';
import PrincipalHistorizationOverviewViewModelType from '@/ViewModels/Controls/PrincipalHistorizationOverviewViewModel';
import PrincipalHistorizationSelectionType from '@/Controls/PrincipalHistorizationSelection';
import PrincipalHistorizationPreviewType from '@/Controls/PrincipalHistorizationPreview';

export default class PrincipalHistorizationOverview extends Control {

    private PrincipalHistorizationSelection = ComponentManager.getControl<typeof PrincipalHistorizationSelectionType>('PrincipalHistorizationSelection');
    private PrincipalHistorizationPreview = ComponentManager.getControl<typeof PrincipalHistorizationPreviewType>('PrincipalHistorizationPreview');
    private jQueryControl: JQuery;
    private selection: PrincipalHistorizationSelectionType;
    private preview: PrincipalHistorizationPreviewType;

    public constructor(private viewModel: PrincipalHistorizationOverviewViewModelType, private element?: JQuery<HTMLElement>) {
        super(viewModel, element);

        this.onWidgetCreated(this.onWidgetCreatedCallback.bind(this));
    }

    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.jQueryControl = this.element || $('<div><div class="left"></div><div class="right"></div></div>');

        this.widget(null);

        return this.jQueryControl;
    }

    private onWidgetCreatedCallback(widget: null): void {
        this.applyBindings(this.jQueryControl, {
            controlName: 'principalhistorizationoverview',

            loader: this.viewModel.isBusy,

            controlIdent: this.identifier,

            tooltip: this.viewModel.tooltip,

            invalid: this.viewModel.invalidationText,

            visible: this.viewModel.isVisible,

            styles: this.definePureComputed({
                read: () => {
                    let styles = [];

                    return styles;
                }
            }),

            states: this.definePureComputed({
                read: () =>{
                    let states = [];

                    if (this.viewModel.isRequired() === true) {
                        states.push('required');
                    }

                    if (this.viewModel.isValid() === true) {
                        states.push('valid');
                    } else {
                        states.push('invalid');
                    }

                    if (this.viewModel.isSummaryMode === true) {
                        states.push('summary');
                    }

                    if (this.viewModel.isEnabled() === true) {
                        states.push('enabled');
                    } else {
                        states.push('disabled');
                    }

                    return states;
                }
            })
        });

        if (this.viewModel.selection != null) {
            this.selection = new this.PrincipalHistorizationSelection(this.viewModel.selection);
            let tuple = this.selection.getTuple();

            tuple.control.appendTo(this.jQueryControl.find('.left'));
        }

        if (this.viewModel.preview != null) {
            this.preview = new this.PrincipalHistorizationPreview(this.viewModel.preview);
            let tuple = this.preview.getTuple();

            tuple.control.appendTo(this.jQueryControl.find('.right'));
        }
    }
}

ComponentManager.setControl('PrincipalHistorizationOverview', PrincipalHistorizationOverview, 'RADPresentation.HTMLClient.DefaultViewExtensions');